﻿import { Directive } from "@app/components/directive";
import { Dirs } from "@app/helpers/dirs";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { DrawerService } from "@app/services/drawer.service";

export interface ISfdcHeaderScope extends ng.IScope {
    drawerService: DrawerService;
}

@NgComponent({
    token: Token.KbSfdcHeader,
    dependencies: [
        Token.$Timeout,
        Token.DrawerService,
    ]
})
export class KbSfdcHeader extends Directive {
    constructor(
        $timeout: ng.ITimeoutService,
        drawerService: DrawerService
    ) {
        super();

        this.restrict = "EA";
        this.template = Dirs.component("kb-sfdc-header");
        this.scope = false;
        this.replace = true;

        this.controller = [
            "$scope",
            "$element",
            "$attrs",
            "$transclude",
            "$templateCache",
            Token.$Compile.key,
            function(
                $scope: ISfdcHeaderScope,
                $element: ng.IAugmentedJQuery,
                $attrs: ng.IAttributes,
                $transclude: ng.ITranscludeFunction,
                $templateCache: ng.ITemplateCacheService,
                $compile: ng.ICompileService) {
                // set the scope on the controller so children can access it
                this.scope = $scope;
                $scope.drawerService = drawerService;
            }];

        this.link = (scope: ISfdcHeaderScope, element: JQuery, atts, ngModel: ng.INgModelController) => {
                
        };
    }
}
